import { Link } from 'react-router-dom';
import { allComics } from '@/mocks/comics';

export default function FeaturedComics() {
  const featured = [...allComics]
    .sort((a, b) => b.rating - a.rating)
    .slice(0, 6);

  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            精选推荐
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            高分好评漫画，品质之选，不容错过
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {featured.map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group cursor-pointer animate-fade-in-up"
                style={{ animationDelay: `${index * 80}ms` }}
            >
              <div className="relative overflow-hidden rounded-xl bg-background-50 mb-3 aspect-[3/4]">
                <img
                  src={comic.cover}
                  alt={`${comic.title} - 香香漫画推荐`}
                  title={`${comic.title} - 高分推荐漫画`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 to-transparent p-3">
                  <div className="flex items-center gap-1">
                    <div className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-star-fill text-accent-400 text-xs"></i>
                    </div>
                    <span className="text-background-50 text-xs font-medium">{comic.rating}</span>
                  </div>
                </div>
              </div>
              <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 line-clamp-1 mb-1">
                {comic.title}
              </h3>
              <p className="text-xs text-foreground-400 line-clamp-1">{comic.category} · {comic.author}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}